"use client";

import { DirectusImage } from "@/components/DirectusImage";
import { AspectRatio } from "@radix-ui/react-aspect-ratio";
import RouterLink from "@/components/ui/router-link";
import { format } from "date-fns";
import { dataCollect } from "@/lib/analytics";

export default function ArticleCover(props: {
  data?: {
    url?: string;
    title?: string;
    description?: string;
    date?: number;
    cover?: string;
    coverRatio?: number;
    eventName?: string;
  } & Record<string, any>;
}) {
  let mapUrl: string | undefined;
  if (props.data?.url) {
    const urlArr = props.data.url.split("/");
    const mapArr = urlArr.map((item) => {
      if (item.startsWith(":")) {
        const key = item.replace(":", "");
        return (props.data as any)[key];
      }
      return item;
    })
    mapUrl = mapArr.join("/");
  }
  const clickEvent = () => {
    if (props.data?.eventName) {
      dataCollect(props.data.eventName, {
        title: props.data.title
      })
    }
  }
  return (
    <RouterLink target="_blank" href={mapUrl} onClick={clickEvent}>
      <div className="flex flex-col">
        {props.data?.cover && (
          <AspectRatio ratio={props.data?.coverRatio || 1}>
            <DirectusImage
              className="w-full object-cover"
              alt={props.data?.title || ""}
              id={props.data?.cover}
              fill
            />
          </AspectRatio>
        )}
       
        <h2 className="mt-2 text-2xl line-clamp-2">{props.data?.title}</h2>
        <p className="mt-2 text-[#777] line-clamp-2">{props.data?.description}</p>
        {props.data?.date && (
          <p className="mt-2 text-[#777]">
            {format(new Date(props.data.date), "yyyy-MM-dd")}
          </p>
        )}
      </div>
    </RouterLink>
  )
}
